// Module
var code = "<span data-bind=\"attr: { title: 'Nearest known location at ' + timestampText }\">\n    <span data-bind=\"text: latitudeText\"></span>\n    &nbsp;\n    <span data-bind=\"text: longitudeText\"></span>\n</span>";
// Exports
module.exports = code;